<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent(); scrollContentToTop()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<app-loading-circle *ngIf="loading"> </app-loading-circle>

<ion-content
  *ngIf="!showRetry && !loading"
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div
    #content
    class="content-list"
    [ngClass]="{ 'content-list--with-button': selectedItem }"
  >
    <app-ion-common-label
      [id]="idLabelExpeditionState"
      class="document-type-label1"
      labelStyle="display-rg"
      [labelDescription]="titleLabelPage"
    >
    </app-ion-common-label>

    <div
      class="conent-center conent-center--mrt-lg"
      [attr.aria-hidden]="ariaHidden"
    >
      <div class="my-search">
        <app-ion-common-search
          [id]="idInputSearchExpeditionState"
          [textSearch]="textSearch"
          [ariaLabel]="'Busque por estados'"
          [placeholder]="'Busque por estados'"
          [list]="expeditionState"
          [fieldSearch]="fieldSearch"
          [textError]="'Órgão de estado não encontrado'"
          (sendTextSearch)="textSearch = $event"
        >
        </app-ion-common-search>
      </div>

      <app-ion-common-radio
        [id]="idRadioExpeditionState"
        class="document-type-options"
        [itens]="expeditionState"
        [disabled]="!this.edit"
        [selectedValue]="selectedItem"
        [textSearch]="textSearch"
        [fieldSearch]="fieldSearch"
        (changeRadio)="selectedItem = $event; changeValue()"
        (valueNameRadio)="selectedName = $event"
      ></app-ion-common-radio>
    </div>
  </div>

  <app-ion-common-button
    [id]="idButtonExpeditionState"
    class="hidden"
    [ngClass]="{ hidden: selectedItem?.length === 0 }"
    [attr.aria-hidden]="selectedItem?.length === 0"
    label="Continuar"
    (clickButton)="clickNext()"
  ></app-ion-common-button>
</ion-content>

<ion-content *ngIf="showRetry">
  <app-ion-common-retry
    [id]="idRetryExpeditionState"
    [headerId]="headerId"
    (sendEventRetry)="getDomainState()"
  >
  </app-ion-common-retry>
</ion-content>
